import cx from "classnames";
import Link from "next/link";
import Flags from "@/components/svg/Flags";
import { RACING_TRACK_LINK_CLICKED } from "@/constants/amplitude";
import { Hr_PastTrack } from "@/graphql/gql/graphql";
import { useAmplitude } from "@/utils/hooks/useAmplitude";
import { makeSnakeCase } from "@/utils/horseRacing";
import useHorseRacingRouting from "../hooks/useHorseRacingRouting";
import styles from "./trackList.module.scss";

interface TrackListItemsProps {
  isUs?: boolean;
  title: string;
  tracks: Hr_PastTrack[];
}

function getTrackStyles(count: number) {
  if (count < 12) {
    return styles.grid;
  }
  return styles.gridXL;
}

const TrackListItems = ({ isUs, tracks, title }: TrackListItemsProps) => {
  const countryCode = tracks[0].location?.country;
  const { logAmplitudeEvent } = useAmplitude();
  const { buildHrefObject, buildHrefString } = useHorseRacingRouting();

  return (
    <div className={styles.locationContainer}>
      <p className={styles.trackLocation}>
        <Flags countryCode={isUs ? "USA" : (countryCode ?? "")} />

        {title}
      </p>
      <div className={styles.trackStyles}>
        <ul className={cx(getTrackStyles(tracks.length))}>
          {tracks.map((track) => {
            const trackHref = buildHrefObject(
              track.code ?? "",
              track.name ?? "",
              null,
              null
            );
            const trackUrl = buildHrefString(
              track.code ?? "",
              track.name ?? "",
              null,
              null
            );

            return (
              <li key={track.name}>
                <Link
                  onClick={() => {
                    logAmplitudeEvent(RACING_TRACK_LINK_CLICKED, {
                      Module: "tracks_list",
                      "Link Text": makeSnakeCase(track.name) ?? "unknown_track",
                      "Link URL": trackUrl,
                    });
                  }}
                  href={trackHref}
                >
                  {track.name}
                </Link>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default TrackListItems;
